import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

import BookingCalendar from "./bookingCalendar";
import MobileBookingCalendar from "./MobileBookingCalendar";

const Appointments = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return isMobile ? <MobileBookingCalendar /> : <BookingCalendar />;
};

export default Appointments;
